(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ksein-multiselect-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ksein-multifilter]').forEach(function (form) {
    var params = new URLSearchParams(window.location.search);
    var query = params.get('q') || '';

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      var token = 'tag:"' + input.value.replace(/"/g, '\\"') + '"';
      input.checked = query.indexOf(token) !== -1;
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var clauses = ['tag:"Cheese"'];

      form.querySelectorAll('[data-filter-group]').forEach(function (group) {
        var selected = Array.from(group.querySelectorAll('input:checked')).map(function (input) {
          return 'tag:"' + input.value.replace(/"/g, '\\"') + '"';
        });

        if (selected.length === 1) {
          clauses.push(selected[0]);
        } else if (selected.length > 1) {
          clauses.push('(' + selected.join(' OR ') + ')');
        }
      });

      var selectedCount = form.querySelectorAll('input:checked').length;
      var previewTheme = params.get('preview_theme_id');

      if (selectedCount === 0) {
        var collectionUrl = new URL('/collections/cheese', window.location.origin);
        if (previewTheme) collectionUrl.searchParams.set('preview_theme_id', previewTheme);
        window.location.assign(collectionUrl.toString());
        return;
      }

      var searchUrl = new URL('/search', window.location.origin);
      searchUrl.searchParams.set('type', 'product');
      searchUrl.searchParams.set('options[unavailable_products]', 'last');
      searchUrl.searchParams.set('options[prefix]', 'none');
      searchUrl.searchParams.set('q', clauses.join(' AND '));
      if (previewTheme) searchUrl.searchParams.set('preview_theme_id', previewTheme);
      window.location.assign(searchUrl.toString());
    });

    var clearButton = form.querySelector('[data-ksein-clear]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        var previewTheme = params.get('preview_theme_id');
        var collectionUrl = new URL('/collections/cheese', window.location.origin);
        if (previewTheme) collectionUrl.searchParams.set('preview_theme_id', previewTheme);
        window.location.assign(collectionUrl.toString());
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ksein-print-cheese-note"] && !Shopify.designMode) return;
  try {
    (function(){
  var params=new URLSearchParams(window.location.search);
  var preview=params.get('preview_theme_id');
  if(!preview)return;
  document.querySelectorAll('[data-ksein-tasting-note-link]').forEach(function(link){
    var url=new URL(link.href,window.location.origin);
    url.searchParams.set('preview_theme_id',preview);
    link.href=url.pathname+url.search;
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ksein-product-details"] && !Shopify.designMode) return;
  try {
    (function() {
    function initKseinCheeseDetails(root) {
      if (root.dataset.kseinReady === 'true') return;
      root.dataset.kseinReady = 'true';

      var source = root.querySelector('[data-ksein-cheese-source]');
      var glance = root.querySelector('[data-ksein-at-a-glance]');
      var panel = root.querySelector('[data-ksein-more-panel]');
      var button = root.querySelector('[data-ksein-more-button]');

      if (!source || !glance || !panel || !button) return;

      var destination = null;
      var include = false;

      Array.prototype.slice.call(source.children).forEach(function(node) {
        if (node.tagName === 'H3') {
          var heading = node.textContent.trim().toLowerCase();

          if (heading === 'at a glance') {
            destination = glance;
            include = true;
            glance.appendChild(node.cloneNode(true));
            return;
          }

          if (
            heading.indexOf('taste & texture') !== -1 ||
            heading.indexOf('taste and texture') !== -1 ||
            heading.indexOf('how to serve') !== -1 ||
            heading.indexOf('how to use') !== -1 ||
            heading.indexOf('what to drink') !== -1 ||
            heading.indexOf('pair it with') !== -1 ||
            heading.indexOf('if you like') === 0 ||
            heading.indexOf('want to know') !== -1
          ) {
            destination = panel;
            include = true;
            panel.appendChild(node.cloneNode(true));
            return;
          }

          destination = null;
          include = false;
          return;
        }

        if (include && destination) {
          destination.appendChild(node.cloneNode(true));
        }
      });

      source.remove();

      button.addEventListener('click', function() {
        var isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
        var symbol = button.querySelector('.ksein-more__symbol');
        if (symbol) symbol.textContent = isOpen ? '+' : '−';
      });

      if (!panel.textContent.trim()) {
        root.querySelector('.ksein-more').remove();
      }
    }

    function initAll() {
      document.querySelectorAll('[data-ksein-cheese-details]').forEach(initKseinCheeseDetails);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
